import request from '@/utils/http';
// 获取表头
export const scoreHead = (params) => {
    return request({
        url: `/api-srm-web/bid/bidGetBisSupplierSuccessList`,
        method: 'post',
        data: params
    });
};
// 获取父节点
export const parentList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidGetScoringParentNodeList`,
        method: 'post',
        data: params
    });
};
// 保存
export const saveList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidBatchUpdateBidScoringResult`,
        method: 'post',
        data: params
    });
};
// 提交
export const pullList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidBatchUpdateScoreResultStatus`,
        method: 'post',
        data: params
    });
};